var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "9a55e69eafd30d86b84cd3884b3a73e7e6b9e3c4"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["frontend-nextrequest@nextrequest"] = {
  id: "9a55e69eafd30d86b84cd3884b3a73e7e6b9e3c4"
};